// SPDX-License-Identifier: MIT
// Décisions PURES sur un WindowState. Aucune I/O ; l'UI/le run-manager exécutent.
import { type WindowState, type PlanTier, CHECKPOINT_MINS, REPEAT_THROTTLES } from './usage-types';
import { capTokensFor } from './plan-caps';

export function shouldCheckpoint(s: WindowState): boolean {
  if (s.status === 'throttled') return true;
  return s.projectionMins != null && s.projectionMins < CHECKPOINT_MINS;
}

export function softUpsellUnlocked(throttleCountInWindow: number): boolean {
  return throttleCountInWindow >= REPEAT_THROTTLES;
}

// Estimé pré-build NON bloquant : combien de fenêtres 5 h ce projet va coûter.
// null si pas de plafond chiffré (tier unknown) → l'UI masque l'estimé.
export function estimateWindows(predictedTokens: number, tier: PlanTier): number | null {
  const cap = capTokensFor(tier);
  if (cap == null || cap <= 0) return null;
  return predictedTokens === 0 ? 0 : Math.max(1, Math.ceil(predictedTokens / cap));
}
